import React from 'react'
import PropTypes from 'prop-types'

const DangerIcon = ({ size = 30 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.6137 22.9467L19.5785 5.68193C17.9662 3.14156 14.0358 3.13819 12.4213 5.68193L2.38664 22.9467C0.738412 25.5426 2.73391 28.8297 5.96439 28.8297H26.0351C29.2629 28.8297 31.2619 25.5452 29.6137 22.9467Z"
        fill="#EF3934"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5785 5.68205L29.6138 22.9469C31.262 25.5453 29.2629 28.8298 26.0352 28.8298H5.96442C2.73395 28.8298 0.738446 25.5427 2.38667 22.9469L12.4214 5.68205C14.0359 3.1383 17.9662 3.14168 19.5785 5.68205ZM0.867686 22.027C-1.60733 25.9766 1.56221 30.6053 5.96442 30.6053H26.0352C30.4333 30.6053 33.6081 25.9806 31.1329 22.0273L21.0962 4.75986L21.0776 4.73062C18.7686 1.09261 13.2349 1.08698 10.9223 4.73061L10.9037 4.75987L0.867686 22.027Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8164 20.9C16.8178 20.9 17.6329 20.1372 17.6329 19.2V10.7C17.6329 9.76285 16.8178 9 15.8164 9C14.8151 9 14 9.76285 14 10.7V19.2C14 20.1372 14.8151 20.9 15.8164 20.9ZM14 24.3C14 25.2371 14.8151 26 15.8164 26C16.8178 26 17.6329 25.2371 17.6329 24.3C17.6329 23.3628 16.8178 22.6 15.8164 22.6C14.8151 22.6 14 23.3628 14 24.3Z"
        fill="white"
      />
    </svg>
  )
}

export default DangerIcon

DangerIcon.propTypes = {
  size: PropTypes.number,
}
